import React from 'react';
import '../../../stylesheets/lis-public-view/public-view.css';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import renderHtml from 'react-render-html';

const tz = moment.tz.guess();

const TIME_REGEX = /[0-9]:[0-9]{2}\s[AP]M/i;

class Schedule extends React.Component {

    constructor(props) {
        super(props);
        this.scrollToBottom = this.scrollToBottom.bind(this);
    }

    scrollToBottom() {
        const thePanel = Array.from(document.getElementsByClassName('homepage-schedule-panel')).at(0);
        const fullScheduleLink = document.querySelector('a[href="/schedule"]');
        if (thePanel && fullScheduleLink) {
            thePanel.scroll(0, thePanel.scrollHeight);
            fullScheduleLink.focus();
        }
    }

    render() {
        return (
            <div>
                <div className='homepage-header-schedule-holder '>
                    <a className="skip-link" onClick={() => { return false }} id="skip-schedule-link" href="#full-schedule">Skip to Full Schedule Link</a>
                    <h3 className="homepage-header">Upcoming Schedule{tz !== "America/New_York" && <small>*</small>}</h3>                    
                </div>
                <hr style={{ margin: '0' }} />
                {!this.props.isLoaded ?
                    <div className="center-spinner spinner small-height" />
                    :
                    <>
                        {this.props.schedule.length === 0 &&
                            <div className="center" style={{ fontFamily: "Lato" }}>
                                <span>Nothing Scheduled</span>
                            </div>
                        }
                        <div className='homepage-schedule-panel'>
                            {this.props.schedule.map((date, dateIndex) =>
                                <div className="homepage-schedule-item" key={dateIndex}>
                                    <div className="homepage-schedule-date">
                                        <h4>{moment(date.Date).format('MMMM D, YYYY')}</h4>
                                    </div>
                                    {date.Times.map((time, timeIndex) => {
                                        return <div key={`${dateIndex}-${timeIndex}`}>
                                            {time.Items.length > 0 &&
                                                <ul className="small-text">
                                                    {time.Items.map((item, itemIndex) =>
                                                        <li key={`${dateIndex}-${timeIndex}-${itemIndex}`}>
                                                            <span className="schedule-time">{TIME_REGEX.test(item.ScheduleTime?.replaceAll(".", "").toUpperCase()) && item.ScheduleTime?.replaceAll(".", "").toUpperCase()}</span>
                                                            <div className='schedule-info'>
                                                                <div>
                                                                    <span className="schedule-owner">{item.OwnerName} {item.IsCancelled && <span className="fail"> CANCELLED</span>}</span>
                                                                </div>
                                                                <div>
                                                                    <span style={{ whiteSpace: 'pre-wrap', fontSize: ".85em", lineHeight: "1em" }}>{!TIME_REGEX.test(item.ScheduleTime?.replaceAll(".", "").toUpperCase()) && item.ScheduleTime}</span>
                                                                    {!["House Convenes", "Senate Convenes"].includes(item.OwnerName) &&
                                                                        <p style={{ whiteSpace: 'pre-wrap', margin: "0", fontSize: ".85em", lineHeight: "1em" }}>{item.RoomDescription}</p>
                                                                    }
                                                                    <span style={{ fontSize: ".85em", lineHeight: "1em" }}>{item.Description && renderHtml(item.Description)}</span>
                                                                </div>
                                                                {item.LinkURL !== undefined && item.LinkURL !== "" &&
                                                                    <span style={{ fontSize: ".85em", lineHeight: "1em", margin: "4px 0 0 -2px" }}>
                                                                        {(item.ScheduleType === "Committee" || item.ScheduleType === "Docket") && item.OwnerID !== undefined
                                                                            ? <React.Fragment> <Link to={item.LinkURL.substr(item.LinkURL.indexOf(".gov") + 4, item.LinkURL.length + 1)} target="_blank">Docket Info</Link></React.Fragment>
                                                                            : <Link to={item.LinkURL.substr(item.LinkURL.indexOf(".gov") + 4, item.LinkURL.length + 1)} target="_blank">Docket Info</Link>
                                                                        }
                                                                    </span>
                                                                }
                                                            </div>
                                                        </li>
                                                    )}
                                                </ul>
                                            }
                                        </div>
                                    }
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="homepage-links" style={{ marginTop: "10px" }}>
                            <Link id="full-schedule" to="/schedule">Full Schedule</Link>
                        </div>
                        {tz !== "America/New_York" && <div><small><em>*Times are displayed in Eastern Time</em></small></div>}
                    </>
                }
            </div>
        );
    }
}

export default Schedule;
